import Link from "@mui/material/Link"
import {styled} from "@mui/material/styles"

type CharacterLinkProps = {
    disabled?: boolean
    selected?: boolean
    component: string
}

export const CharacterLink = styled(Link)<CharacterLinkProps>`
    && {
        padding: 0.1875rem;
        overflow-anchor: none;
        font-size: 0.875rem;
        font-family: ${props =>
            `${props.theme.colours.font.primary.medium.family}, ${props.theme.colours.font.default}`};
        font-weight: ${props => props.theme.colours.text.navigation.fontWeight};
        color: ${props => {
            if (props.disabled) {
                return props.theme.colours.text.disabled
            }
            return props.selected ? props.theme.colours.text.default : props.theme.colours.text.hyperlink
        }};
        cursor: ${props => (props.disabled ? "default" : "pointer")};
    }
    &&:hover {
        text-decoration: ${props => (props.disabled ? "none" : "underline")};
    }
`
